export const API_BASE_URL = "https://api.ava.rbt.ir/api/";
